import styled from 'styled-components';
import { colors, fontFamily } from '../../Utils/tokens';

const titleGradient = `linear-gradient(179.42deg, ${colors.aiPink} 11.06%, ${colors.aiBlue} 77.16%)`;
const badgeGradient = `linear-gradient(163.37deg, ${colors.aiPink} 15.71%, ${colors.aiBlue} 84.29%)`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  font-family: ${fontFamily};
`;

export const Welcome = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

/** "AiIcon": selo "Assistente de IA" com borda e texto em gradiente. */
export const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px 3px 5px;
  border: 1px solid ${colors.aiPink};
  border-radius: 999px;
  background-color: ${colors.surface};
  box-shadow: 1px 1px 6px 0px rgba(63, 94, 251, 0.12),
    -1px -1px 6px 0px rgba(252, 70, 107, 0.12);

  img {
    width: 12px;
    height: 12px;
  }

  span {
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    white-space: nowrap;
    background-image: ${badgeGradient};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.25;
  color: ${colors.onSurface};

  .name {
    background-image: ${titleGradient};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .subtitle {
    display: block;
  }
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.25;
  color: ${colors.onSurfaceVariant};
`;

export const Prompts = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 12px;
  width: 100%;
`;

/** "Chat AI / Chat / Prompt" */
export const PromptCard = styled.button`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  min-width: 200px;
  height: 122px;
  padding: 11px;
  border: 1px solid ${colors.surfaceOutline};
  border-radius: 6px;
  background-color: ${colors.surface};
  font-family: ${fontFamily};
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover,
  &:focus-visible {
    background-color: ${colors.surfaceContainer};
    outline: none;
  }
`;

export const PromptIcon = styled.span`
  display: flex;
  padding: 6px;
  border-radius: 6px;
  background-color: ${colors.secondary};

  img {
    width: 16px;
    height: 16px;
  }
`;

export const PromptDetails = styled.span`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  justify-content: flex-end;
  gap: 4px;
  width: 100%;
  min-height: 0;
  font-size: 12px;
  line-height: 1.5;

  strong {
    overflow: hidden;
    font-weight: 600;
    color: ${colors.onSurface};
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: -webkit-box;
    overflow: hidden;
    font-weight: 400;
    color: ${colors.onSurfaceVariant};
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
